import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const createFormActions = createActionGroup({
  source: 'Einreichung - create form',
  events: {
    'Create': props<{ antrag: any }>(),
    'Create success': props<{ response: any }>(),
    'Create failed': props<{ response: any }>(),
    'Clear store': emptyProps(),
  },
});
